/* eslint-disable no-undef */
import { IApps } from "types/applications.type";
import api from "./ApiService";

const getReport = (data: any) => {
  return api
    .post<IApps>(process.env.REACT_APP_API_BASE_URL + `/entities`, data)
    .then((response: any) => {
      return response;
    });
};

const ReportService = {
  getReport,
};
export default ReportService;
